/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  appName: "OurEdu",
  apiUrl: "https://abilitesbe.testenv.tech/api/v1/",
  mediaBaseUrl: "https://abilitesbe.testenv.tech/api/v1/",
  lang: "ar",
  firebase: {
    apiKey: "AIzaSyD9dLPRH_TC2ow99u4fx66yIevHscUZOwY",
    authDomain: "ouredu-240bf.firebaseapp.com",
    databaseURL: "https://ouredu-240bf.firebaseio.com",
    projectId: "ouredu-240bf",
    storageBucket: "ouredu-240bf.appspot.com",
    messagingSenderId: "500852686542",
    appId: "1:500852686542:web:c23910e3f1782d09581a9f",
    measurementId: "G-5MEHYH2KT6",
  },
  ckeditorApiKey: "Z3C7DFLT",
  FlmngrAccessKey: "Z3C77536699F6ED9A48AB8B874A4663B98CF",
  FlmngrUrlFiles: "https://testenv-filemanager.s3.us-east-2.amazonaws.com/",
};
